export const createFilter = (implementation) => {
    const requiredMethods = ['applyFilter', 'renderFilter', 'getInitialState', 'reset'];

    requiredMethods.forEach(method => {
        if (typeof implementation[method] !== 'function') {
            throw new Error(`Filter must implement ${method} method`);
        }
    });

    return {
        type: implementation.type || 'custom',
        ...implementation
    };
};
